import React from "react";
import ErrorMessage from "../ErrorMessage";
import "./input.css";

export function InputType(props: any) {
  const {
    field,
    form: { touched, errors, setFieldValue },
    withFeedbackLabel = true,
    customFeedbackLabel,
    type = "text",
    placeholder,
    cssclassname,
    showerror = "true",
    maxLength,
    isLabel,
    label,
    minLength,
    iscapital = false,
    width = "100%",
    height = "54px",
    backgroundcolor = "#fff",
    multiline,
    readOnly
  } = props;

  const setFieldValueForNubmer = (e: any) => {
    if (e.target.value.length <= maxLength && !isNaN(Number(e.target.value))) {
      setFieldValue(field.name, e.target.value);
      return true;
    }
    return true;
  };

  const setFieldValueForNubmerPassword = (e: any) => {
    if (e.target.value.length <= maxLength && !isNaN(Number(e.target.value))) {
      setFieldValue(field.name, e.target.value);
      return true;
    }
    return true;
  };

  const onChangeText = (e: any) => {
    if (type === "number") setFieldValueForNubmer(e);
    if (type === "password") setFieldValueForNubmerPassword(e);
    else
      setFieldValue(
        field.name,
        iscapital ? e.target.value.toUpperCase() : e.target.value
      );
    if (props.onChange) props.onChange(e.target.value);
  };
  const hndlKeyUp = (e: any) => {
    if (props.onKeyUp) return props.onKeyUp(e);
    return null;
  };
  const hndlKeyDown = (e: any) => {
    if (type === "number")
      return ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault(e);
  };

  const hndlFocus = (e: any) => {
    // if (props.checkFocus) return props.checkFocus(true, e);
    // return false;
    if (props.onFocus) return props.onFocus(e);
    return null;
  };

  const handleOnInput = (e: any) => {
    if (type === "number")
      return e.target.value = e.target.value.slice(0, maxLength)
  }
  return (
    <>
      {
        multiline ?
          <textarea
            type={type}
            placeholder={placeholder}
            autoComplete="off"
            {...field}
            {...props}
            onChange={onChangeText}
            className="text-area-input"
            onKeyUp={(e) => hndlKeyUp(e)}
            onFocus={(e) => hndlFocus(e)}
            onKeyDown={(e) => hndlKeyDown(e)}
            maxLength={maxLength}
            onInput={(e) => handleOnInput(e)}
          />
          :
          <input
            type={type}
            placeholder={placeholder}
            autoComplete="off"
            {...field}
            {...props}
            onChange={onChangeText}
            style={{
              width: width,
              height: height,
              backgroundColor: backgroundcolor,
            }}
            onKeyUp={(e) => hndlKeyUp(e)}
            onFocus={(e) => hndlFocus(e)}
            onKeyDown={(e) => hndlKeyDown(e)}
            maxLength={maxLength}
            onInput={(e) => handleOnInput(e)}
            readOnly={readOnly}
          />
      }
      {showerror === "true" && errors[field.name] && touched[field.name] && (
        <ErrorMessage text={errors[field.name]} />
      )}
    </>
  );
}